<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>{{$t('text')}}</label>
        <b-input class="input-pentagro" v-model="node.text"></b-input>
      </div>
    </b-form>
  </div>
</template>

<script>
  export default {
    props: {
      node: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
      }
    },

    watch:{
    },

    mounted(){ }
  }
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}
</style>